import LoginModule from './login/login.module';
import loginRouteConfig from './login.route';

export default angular
  .module('sfMobile.login', [LoginModule, 'sfMobile.services.segment'])
  .config(loginRouteConfig).name;
